import Loading from "@/src/components/loading";
import { Input } from "@/src/components/universalInput";
import { DocumentTemplate } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export function RegistryNumberPicker({
  value,
  template,
  onChange,
}: {
  value: number;
  template: DocumentTemplate;
  onChange: (newValue: number) => void;
}) {
  const [lastRegistryNumber, setLastRegistryNumber] = useState(value);
  const [loadedRegistryNumber, setLoadedRegistryNumber] = useState(value);
  const [refreshInput, setRefreshInput] = useState(0);
  const { data, isError, isLoading } = useQuery({
    queryKey: ["RegistryNumberPicker", template?.registryName, template?.id],
    queryFn: async () => {
      if (value) return value;
      let result = await apiFetch(
        "patientDocuments",
        "getAvailableRegistryNumber",
        {
          // registryName: template?.registryName,
          registryName: null,
          templateId: getItemId(template),
        },
        "Erreur lors de la récupération du dernier numéro de registre"
      );
      if (result) {
        console.log("the RegistryNumber result", result);
        setValue(result);
        setLoadedRegistryNumber(result);
        setRefreshInput(refreshInput + 1);
      }
      return result;
    },
  });

  function setValue(newValue: number) {
    setLastRegistryNumber(newValue);
    onChange(newValue);
  }

  return (
    <div className="c1 gap10">
      {isLoading ? (
        <Loading />
      ) : (
        <Input
          key={`${refreshInput}registryNumber`}
          type="number"
          name="Numéro de registre"
          value={lastRegistryNumber}
          onChange={(newValue) => {
            setValue(newValue);
          }}
        />
      )}
      {loadedRegistryNumber != null &&
        lastRegistryNumber - 10 > loadedRegistryNumber && (
          <div className="orange-color">
            Attention: numéro de registre possiblement éronné
          </div>
        )}
    </div>
  );
}
